import React, { useState } from 'react'
import { connect } from 'react-redux'
import { actionSaveReview } from '../../../store/actions/review'
import { formatPrice } from '../../../helpers'

const FormReview = ({
  show,
  onClose,
  trx,
  selectedItem,
  onSave,
  saveReviewState,
  dispatchSaveReview
}) => {
  const [rating, setRating] = useState(0)
  const [hoverRating, setHoverRating] = useState(0)
  const [comment, setComment] = useState('')

  if (!show) return null

  const isSubmitting = saveReviewState?.loading || false

  const handleSaveReview = async () => {
    if (!rating || rating < 1) {
      alert('Silakan pilih rating terlebih dahulu!')
      return
    }

    const starValue = Math.min(Math.max(rating, 1), 5)
    const payload = {
      star: starValue,
      review: comment || '',
      order_id: selectedItem?.id,
      product_id: selectedItem?.product_id,
      can_edit: false,
      is_show: true
    }

    try {
      const result = await dispatchSaveReview(payload)

      if (result && result.status) {
        if (onSave) {
          onSave({ ...payload, rating: starValue, comment }, selectedItem)
        }
        onClose()
      } else {
        alert(result?.message || 'Gagal menyimpan ulasan.')
      }
    } catch (err) {
      alert(err?.message || 'Terjadi kesalahan saat menyimpan ulasan.')
    }
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        padding: '20px'
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: '#fff',
          borderRadius: '10px',
          maxWidth: '450px',
          width: '100%',
          padding: '20px',
          boxShadow: '0 5px 20px rgba(0, 0, 0, 0.2)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 style={{ margin: '0 0 15px 0', fontSize: '1.1em', fontWeight: 'bold', color: '#00a651' }}>
          Review Transaksi <span style={{ textTransform: 'uppercase' }}>({trx?.code})</span>
        </h3>

        {/* Info & Gambar Produk */}
        {selectedItem && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '10px',
              background: '#f9f9f9',
              borderRadius: '6px',
              marginBottom: '15px',
              border: '1px solid #eee'
            }}
          >
            {selectedItem.product?.image && (
              <img
                src={process.env.REACT_APP_IMAGE_URL + selectedItem.product.image}
                alt={selectedItem.product?.name}
                style={{
                  width: '50px',
                  height: '50px',
                  objectFit: 'cover',
                  borderRadius: '4px',
                  border: '1px solid #ddd'
                }}
              />
            )}
            <div>
              <span style={{ fontWeight: '600', color: '#333', fontSize: '0.95em', display: 'block' }}>
                {selectedItem.product?.name || `Produk #${selectedItem.product_id}`}
              </span>
              {selectedItem.price && (
                <span style={{ color: '#777', fontSize: '0.85em', marginTop: '2px', display: 'block' }}>
                  {selectedItem.quantity} x {formatPrice(selectedItem.price, 'Rp.')}
                </span>
              )}
            </div>
          </div>
        )}

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', fontSize: '0.9em', fontWeight: 'bold', marginBottom: '6px', color: '#444' }}>
            Rating Produk:
          </label>
          <div style={{ display: 'flex', gap: '8px' }}>
            {[1, 2, 3, 4, 5].map((star) => (
              <span
                key={star}
                onClick={() => setRating(star)}
                onMouseEnter={() => setHoverRating(star)}
                onMouseLeave={() => setHoverRating(0)}
                style={{
                  fontSize: '2em',
                  cursor: 'pointer',
                  color: star <= (hoverRating || rating) ? '#ffb400' : '#ddd',
                  transition: 'color 0.15s ease-in-out',
                  userSelect: 'none'
                }}
              >
                ★
              </span>
            ))}
          </div>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', fontSize: '0.9em', fontWeight: 'bold', marginBottom: '6px', color: '#444' }}>
            Ulasan Anda:
          </label>
          
          {/* Chip Suggestions Review Positif (Maksimal 6) */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '10px' }}>
            {[
              'Kualitas produk sangat baik',
              'Produk original & halal',
              'Pengiriman sangat cepat',
              'Respon penjual ramah',
              'Harga terjangkau',
              'Packing aman & rapi'
            ].map((chip, idx) => {
              const isSelected = comment.includes(chip)
              return (
                <button
                  key={idx}
                  type="button"
                  onClick={() => {
                    setComment(prev => {
                      if (!prev || !prev.trim()) return chip
                      if (prev.includes(chip)) {
                        return prev.replace(chip, '').replace(/,\s*,/g, ',').replace(/^\s*,\s*/, '').replace(/\s*,\s*$/, '').trim()
                      }
                      return `${prev.trim()}, ${chip}`
                    })
                  }}
                  style={{
                    padding: '4px 10px',
                    fontSize: '0.78em',
                    borderRadius: '16px',
                    border: isSelected ? '1px solid #00a651' : '1px solid #ddd',
                    background: isSelected ? '#e8f5e9' : '#fafafa',
                    color: isSelected ? '#00a651' : '#555',
                    cursor: 'pointer',
                    fontWeight: isSelected ? 'bold' : 'normal',
                    outline: 'none',
                    transition: 'all 0.15s ease-in-out'
                  }}
                >
                  {isSelected ? '✓ ' : '+ '}{chip}
                </button>
              )
            })}
          </div>

          <textarea
            rows="4"
            placeholder="Tulis ulasan dan pengalaman Anda membeli produk ini..."
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              borderRadius: '6px',
              border: '1px solid #ccc',
              fontSize: '0.9em',
              resize: 'vertical',
              outline: 'none',
              boxSizing: 'border-box'
            }}
          />
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <button
            onClick={onClose}
            disabled={isSubmitting}
            style={{
              padding: '8px 16px',
              background: '#f5f5f5',
              color: '#555',
              border: '1px solid #ccc',
              borderRadius: '6px',
              cursor: isSubmitting ? 'not-allowed' : 'pointer',
              fontSize: '0.9em',
              outline: 'none'
            }}
          >
            Batal
          </button>
          <button
            disabled={!rating || rating === 0 || isSubmitting}
            onClick={handleSaveReview}
            style={{
              padding: '8px 20px',
              background: (!rating || rating === 0 || isSubmitting) ? '#ccc' : '#00a651',
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              cursor: (!rating || rating === 0 || isSubmitting) ? 'not-allowed' : 'pointer',
              fontWeight: 'bold',
              fontSize: '0.9em',
              outline: 'none'
            }}
          >
            {isSubmitting ? 'Menyimpan...' : 'Simpan'}
          </button>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    saveReviewState: {
      loading: state.review?.saveReview?.loading || false,
      payload: state.review?.saveReview?.payload || null,
      error: state.review?.saveReview?.error || null
    }
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchSaveReview: (data) => dispatch(actionSaveReview(data))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FormReview)
